function toCurrencyFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits:2, maximumFractionDigits: 2});
}

function toNumberFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"decimal", minimumFractionDigits:2, maximumFractionDigits: 2});
}
function setDefaultWizardStart(){
    const queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);

    if(urlParams.has('sw') ){
       if(urlParams.get('sw') === 'd' ){
                window.wizardStart='StartWithDiamond';
                wizardStart='StartWithDiamond';
                localStorage.setItem("wizardStart", JSON.stringify(window.wizardStart));

        }
        else {
            window.wizardStart='StartWithSetting';
            wizardStart='StartWithSetting';
            localStorage.setItem("wizardStart", JSON.stringify(window.wizardStart));
        }
    }
  else if(queryString.includes('?did')){
   window.wizardStart='StartWithDiamond';
     wizardStart='StartWithDiamond';
     localStorage.setItem("wizardStart", JSON.stringify(window.wizardStart));
  }
    window.wizard.stepId=1; 
    return wizardStart;
}

function setWizardStepId(){
    let startWith = JSON.parse(localStorage.getItem('wizardStart'));
    let wizardActualPage = sessionStorage.getItem('wizardActualPage');
    switch(wizardActualPage){
        case 'dyor-diamond-detail':
            if(startWith == 'StartWithDiamond'){
                window.wizard.stepId=1;
            }
            else {
                window.wizard.stepId=2;
            }
            break;
        case 'dyor-diamonds':
            if(startWith == 'StartWithDiamond'){
                window.wizard.stepId=1;
            }
            else {
                window.wizard.stepId=2;
            }
            break;
        case 'dyor-wizard-settings-collection':
            if(startWith == 'StartWithDiamond'){
                window.wizard.stepId=2;
            }
            else {
                window.wizard.stepId=1;
            }
            break;
        case 'dyor-wizard-completering':
                window.wizard.stepId=3;
            break;
        default:
            window.wizard.stepId=1;
            break;
    }
}

function getCaratDictionaryValueForWizard(carat){
    // get the integer part of the carat
    // Determine the lower bound
  let lowerBound = Math.floor(carat);
  let remainder = carat - lowerBound;
  let topNumber;
  if (remainder < 0.30) {
    topNumber = lowerBound + 0.29;
  } else if (remainder < 0.46) {
    topNumber = lowerBound + 0.45;
  } else {
    topNumber = lowerBound + 0.99;
  }

  // Increment the lower bound for the next range
  let increment = (lowerBound % 2 === 0) ? 0.46 : 0.53;
  if (carat > topNumber) {
    topNumber = lowerBound + increment + 0.99;
  }

  return 'dyo_carat_' + topNumber.toFixed(2).replace(".","-");
}

function changeWizardSelection(type){
    let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));
    switch(type){
        case 'setting':
         if(wizardInfo != null){
           if(wizardInfo.stone_shape != null){
             var wizardInfo_stone_shape = true;
           }
         }
       if(wizardInfo_stone_shape == true){
       if (confirm("Changing your setting will delete your diamond selection. Are you sure you want to do this?")) {
          if(wizardInfo != null){
               window.localStorage.removeItem('wizardInfo_dyoe');
               window.location.href = '/collections/design-your-own-earrings?sw=s';
            }
           }
        }else{
         window.localStorage.removeItem('wizardInfo_dyoe');
           window.location.href = '/collections/design-your-own-earrings?sw=s';
        }
          break;
        case 'diamond':
            var diamond_step = localStorage.getItem("diamond_page_step");
             if(diamond_step != null){
             localStorage.removeItem("diamond_page_step");
             }
            if(wizardInfo.setting_allowed_shapes != null){
               localStorage.setItem("setting_allowed_shapes",wizardInfo.setting_allowed_shapes);
               //wizardInfo.setting_allowed_shapes = []
             }
            if(wizardInfo.setting_max_carat_size != null && wizardInfo.setting_min_carat_size != null){
               localStorage.setItem("setting_max_carat_size",wizardInfo.setting_max_carat_size);
              localStorage.setItem("setting_min_carat_size",wizardInfo.setting_min_carat_size);
               // wizardInfo.setting_max_carat_size = 11.58;
               // wizardInfo.setting_min_carat_size = 0.25;
             
             }
            if(wizardInfo != null){
                wizardInfo.stone_shape = null;
                wizardInfo.stone_carat = null;
                wizardInfo.stone_price = null;
                wizardInfo.stone_image_url = null;
                wizardInfo.stone_clarity = null;
                wizardInfo.stone_color = null;
                wizardInfo.stone_cut = null;
                wizardInfo.stone_delivery = null;
                wizardInfo.stone_id = null;
                wizardInfo.stone_image_url = null;
                wizardInfo.stone_shape1 = null;
                wizardInfo.stone_carat1 = null;
                wizardInfo.stone_price1 = null;
                wizardInfo.stone_image_url1 = null;
                wizardInfo.stone_clarity1 = null;
                wizardInfo.stone_color1 = null;
                wizardInfo.stone_cut1 = null;
                wizardInfo.stone_delivery1 = null;
                wizardInfo.stone_id1 = null;
                wizardInfo.stone_image_url1 = null;
                localStorage.setItem("wizardInfo_dyoe", JSON.stringify(wizardInfo));
            }
            if(!wizardInfo.setting_variant_id || wizardInfo.setting_variant_id == 0){

                //There's no setting selected so we should clear the LocalStorage because the user is restarting the wizard
                window.localStorage.removeItem('wizardInfo');
                window.localStorage.removeItem('wizardSessionDate');
                window.localStorage.removeItem('latestSearch');
                window.location.href = '/pages/dyoe-lab-grown-diamonds?sw=d';
            }
            else {
              window.location.href = '/pages/dyoe-lab-grown-diamonds?sw=d';
            }
            break;
    }
}
function loadWizard(){   
    let screenWidth = screen.width;
    let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));
    let wizardSessionDate = JSON.parse(localStorage.getItem('wizardSessionDate'));
    if(wizardSessionDate){
        // let's parse the date
        let date = new Date(wizardSessionDate);
        //if more than 4 hours have passed let's clear the wizard/localStorage and all that stuff
        if((new Date() - date) > 14400000){
            localStorage.removeItem('wizardInfo');
            localStorage.removeItem('wizardSessionDate');
            localStorage.removeItem('latestSearch');
            localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));
            switch(wizardStart){
                case 'StartWithDiamond':
                    window.location.href = '/pages/dyoe-lab-grown-diamonds?sw=d';
                    break;
                case 'StartWithSetting':
                    window.location.href = '/collections/design-your-own-earrings?sw=s';
                    break;
            }
        }
        else {
            localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));
        }
    }
    else {
        // Not even a date, let's clear the localStorage
        localStorage.removeItem('wizardInfo_dyoe');
        localStorage.removeItem('wizardStart');
        localStorage.removeItem('wizardSessionDate');
        localStorage.removeItem('latestSearch');
        localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));

    }
    // Let's do some validations
    // Is wizardStart null? If so, let's set it to default
    if (wizardStart == null || wizardStart == '' || wizardStart == 'undefined') {
       wizardStart = setDefaultWizardStart();
    }
    else {
        // If start with setting we need to check that we have a setting selected
        if (wizardStart == 'StartWithSetting') {
            let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));
            if (wizardInfo == null || wizardInfo == '' || wizardInfo == 'undefined') {
                wizardStart = setDefaultWizardStart();   
            }
            else {
                if (wizardInfo.setting_product_name == null || wizardInfo.setting_product_name == '' || wizardInfo.setting_product_name == 'undefined') {
                    //Let's check if there's a diamond, if there's a diamond then we have to change the startWith to diamond
                    if (wizardInfo.stone_shape != null && wizardInfo.stone_shape != '' && wizardInfo.stone_shape != 'undefined') {
                        window.wizardStart='StartWithDiamond';
                        wizardStart='StartWithDiamond';
                        localStorage.setItem("wizardStart", JSON.stringify(window.wizardStart));
                        
             
                    }
                }
            }
        }
        else {
            // If start with diamond we need to check that we have a diamond selected
            if (wizardStart == 'StartWithDiamond') {
                let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));
                if (wizardInfo == null || wizardInfo == '' || wizardInfo == 'undefined') {
                    wizardStart = setDefaultWizardStart();   
                }
                else {
                    if (wizardInfo.stone_shape == null || wizardInfo.stone_shape == '' || wizardInfo.stone_shape == 'undefined') {
                        //Let's check if there's a setting, if there's a setting then we have to change the startWith to setting
                        if (wizardInfo.setting_product_name != null && wizardInfo.setting_product_name != '' && wizardInfo.setting_product_name != 'undefined') {
                            window.wizardStart='StartWithSetting';
                            wizardStart='StartWithSetting';
                            localStorage.setItem("wizardStart", JSON.stringify(window.wizardStart));
                                
                        }
                    }
                }
            }
        }
        setWizardStepId();

    }

    let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_dyoe'));
    if (screenWidth >= 800) {
        let step3
        switch (wizardStart) {
            case 'StartWithSetting':        
                loadDesktopStartWithSettingWizard();
                break;

            case 'StartWithDiamond':                
                loadDesktopStartWithDiamondWizard();
                break;

            default:
                break;
        }

    } else {
        loadMobileWizard();
        
    }
}

function loadDesktopStartWithSettingWizard(){

    let wizardInfo;
    let currentCurrency = Shopify.currency.active;
    let currentCurrencySymbol = $('body').attr('data-currency');
    let currentRate = window.Shopify.currency.rate;
    wizardInfo = localStorage.getItem('wizardInfo_dyoe'); 
    let wizardStart;
    wizardStart= JSON.parse(localStorage.getItem('wizardStart'));
    let price;
    let priceStone;
    let settingSelected = false;
    let stoneSelected = false;
    
    if (wizardInfo != null) {
        wizardInfo = JSON.parse(wizardInfo); 
         price = currentCurrencySymbol+' '+toNumberFormat((wizardInfo.setting_variant_price/100));  
         priceStone = currentCurrencySymbol+' '+toNumberFormat(wizardInfo.stone_price * currentRate + wizardInfo.stone_price1 * currentRate );
    }
    else {
        wizardInfo = window.wizard;
    }
  if(wizardInfo != null){
    let stone_image_url = wizardInfo.stone_image_url;
     if(stone_image_url != null ){
    $('.banner_size_images').find('.banner_size_each img').attr('src',stone_image_url);
    }
  }
    switch (window.wizard.stepId) {
        case 1:
            //console.log("Over here, wizardInfo", wizardInfo);
            // Let's validate if we have any selections in localStorage, if not, let's present the default
            document.getElementById("nro-1").innerHTML=1;
            document.getElementById("nro-2").innerHTML=2; 
            let step1 = document.getElementById("step1");
            step1.classList.add('step-select');
            stepPrev = document.getElementById("step0");
            stepPrev.classList.add('step-border');
          
            if(wizardInfo == null){    
               
                /**Step 1 selected */
                document.getElementById('title-1-step1').innerHTML = `Choose Setting`;
                //document.getElementById('col-step-1').classList.add('col-wizard-margin-Noselected');
                document.getElementById('info-wizard-step-1').style.display="none";               
                document.getElementById('img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/earrings.png?v=1752575110`;
                document.getElementById('img-wizard-step1').classList.add('img-step-1-noSelected');
                /**Step 2 NO selected */
                //document.getElementById('col-step-2').classList.add('col-wizard-margin-Noselected');
                document.getElementById('img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                document.getElementById('img-wizard-step2').classList.add('img-step-1-noSelected');
                document.getElementById('title-1-step2').innerHTML = `Choose Diamonds`;
                document.getElementById('subtitle-1-step2').innerHTML = ` <a class="title-step title-middle" href="/pages/dyor-diamonds">Browse Diamonds</a>`;
                document.getElementById('img-wizard-step2').classList.add('img-step-2-noSelected');
                /**Step 3 NO selected */
                //document.getElementById('col-step-3').classList.add('col-wizard-margin-Noselected');
                //document.getElementById('subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="">Select Chain Length Size</a>`;
            }
            else {
                if(wizardInfo.setting_product_name){
                    settingSelected = true;
                    document.getElementById("nro-1").innerHTML=1;
                    document.getElementById("nro-2").innerHTML=2; 
                    /**Step 1 selected */
                    document.getElementById('col-step-1').classList.add('col-wizard-margin-selected');
                    document.getElementById('info-wizard-step-1').innerHTML= `${wizardInfo.setting_product_name} `; 
                    document.getElementById('info-wizard-step-1-2').innerHTML= `${price}`; 
                    document.getElementById('subtitle-1-step1').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
                    document.getElementById('img-wizard-step1').src=`${wizardInfo.setting_image_url}`;
                    document.getElementById('img-wizard-step1').classList.add('img-step-1-selected');
                    //document.getElementById('img-wizard-step1').classList.add('img-step-1-noSelected');
                }
                else {
                    /**Step 1 selected */
                    document.getElementById('title-1-step1').innerHTML = `Choose Setting`;
                    //document.getElementById('col-step-1').classList.add('col-wizard-margin-Noselected');
                    document.getElementById('info-wizard-step-1').style.display="none";               
                    document.getElementById('img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/earrings.png?v=1752575110`;
                    document.getElementById('img-wizard-step1').classList.add('img-step-1-noSelected');
                }
                if(wizardInfo.stone_shape){
                    stoneSelected = true;
                    /**Step 2 selected */
                   /**Step 2 NO selected */
                    var totalCarat = (parseFloat(wizardInfo.stone_carat) + parseFloat(wizardInfo.stone_carat1)).toFixed(2);
                    document.getElementById('col-step-2').classList.add('col-wizard-margin-selected');
                    document.getElementById('title-1-step2').innerHTML = `Choose Lab Grown Diamond`;           
                    document.getElementById('info-wizard-step-2').innerHTML = `${totalCarat} ${wizardInfo.stone_shape} - ${priceStone}`;               
                    document.getElementById('img-wizard-step2').src=`${wizardInfo.stone_image_url}`;
                    document.getElementById('img-wizard-step2').classList.add('img-step-2-selected');
                    document.getElementById('subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/pages/lab-grown-diamond-detail-dyoe?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
                }
                else {
                    //document.getElementById('col-step-2').classList.add('col-wizard-margin-Noselected');
                    document.getElementById('img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                    document.getElementById('img-wizard-step2').classList.add('img-step-1-noSelected');
                    document.getElementById('title-1-step2').innerHTML = `Choose Diamonds`;
                    document.getElementById('img-wizard-step2').classList.add('img-step-2-noSelected');
                }
                if(wizardInfo.setting_variant_id && wizardInfo.stone_shape){
                    //document.getElementById('col-step-3').classList.add('col-wizard-margin-Noselected');
                   
                }
                 /**Step 3 NO selected */
                 else {
                    //document.getElementById('col-step-3').classList.add('col-wizard-margin-Noselected');
                  
                 }
                
            }
            break;
        case 2:                 
            document.getElementById("nro-1").innerHTML=1;
            document.getElementById("nro-2").innerHTML=2;                                 
            let step2 = document.getElementById("step2");
            step2.classList.add('step-select');
            stepPrev = document.getElementById("step1");
            stepPrev.classList.add('step-border');

            document.getElementById('col-step-1').classList.add('col-wizard-margin-selected');
            document.getElementById('info-wizard-step-1').innerHTML= `${wizardInfo.setting_product_name} `; 
            document.getElementById('info-wizard-step-1-2').innerHTML= `${price} `; 
            document.getElementById('subtitle-1-step1').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
            document.getElementById('img-wizard-step1').src=`${wizardInfo.setting_image_url}`;
            document.getElementById('img-wizard-step1').classList.add('img-step-1-selected');

            if(wizardInfo.stone_shape){
                var totalCarat = (parseFloat(wizardInfo.stone_carat) + parseFloat(wizardInfo.stone_carat1)).toFixed(2);
                document.getElementById('col-step-2').classList.add('col-wizard-margin-selected');
                document.getElementById('title-1-step2').innerHTML = `Choose Lab Grown Diamond`;           
                document.getElementById('info-wizard-step-2').innerHTML = `${totalCarat} ${wizardInfo.stone_shape} - ${priceStone}`;               
                document.getElementById('img-wizard-step2').src=`${wizardInfo.stone_image_url}`;
                document.getElementById('img-wizard-step2').classList.add('img-step-2-selected');
                document.getElementById('subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/pages/lab-grown-diamond-detail-dyoe?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
            }
            else {
                //document.getElementById('col-step-2').classList.add('col-wizard-margin-Noselected');
                document.getElementById('title-1-step2').innerHTML = `Choose Diamonds`;
                document.getElementById('img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                document.getElementById('img-wizard-step2').classList.add('img-step-2-noSelected'); 
            }
            if(wizardInfo.setting_variant_id && wizardInfo.stone_shape){
                //document.getElementById('col-step-3').classList.add('col-wizard-margin-Noselected');
               
            }
            else {
                //document.getElementById('col-step-3').classList.add('col-wizard-margin-Noselected');
                //document.getElementById('subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="">Select Chain Length</a>`;
    
            }
            /**Step 3 NO selected */
          
            break;
        case 3:       
            var totalCarat = (parseFloat(wizardInfo.stone_carat) + parseFloat(wizardInfo.stone_carat1)).toFixed(2);
            document.getElementById("nro-1").innerHTML=1;
            document.getElementById("nro-2").innerHTML=2;       
            step3 = document.getElementById("step3");
            step3.classList.add('step-select-3');                
            /**Step 1 NO selected */
            document.getElementById('col-step-1').classList.add('col-wizard-margin-selected');
            document.getElementById('info-wizard-step-1').innerHTML= `${wizardInfo.setting_product_name} `; 
            document.getElementById('info-wizard-step-1-2').innerHTML= `${price} `; 
            document.getElementById('subtitle-1-step1').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
            document.getElementById('img-wizard-step1').src=`${wizardInfo.setting_image_url}`;
            document.getElementById('img-wizard-step1').classList.add('img-step-1-selected');
            /**Step 2 NO selected */
            document.getElementById('col-step-2').classList.add('col-wizard-margin-selected');
            document.getElementById('title-1-step2').innerHTML = `Choose Lab Grown Diamond`;           
            document.getElementById('info-wizard-step-2').innerHTML = `${totalCarat} ${wizardInfo.stone_shape} - ${priceStone}`;               
            document.getElementById('img-wizard-step2').src=`${wizardInfo.stone_image_url}`;
            document.getElementById('img-wizard-step2').classList.add('img-step-2-selected');
            document.getElementById('subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/pages/lab-grown-diamond-detail-dyoe?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
           /**Step 3  selected */
            //document.getElementById('col-step-3').classList.add('col-wizard-margin-Noselected');
          
            

            break;
        default:
            break;
    }
    
}

function loadDesktopStartWithDiamondWizard(){
    let wizardInfo;
    let currentCurrency = Shopify.currency.active;
    let currentCurrencySymbol = $('body').attr('data-currency');
    let currentRate = window.Shopify.currency.rate;
    wizardInfo = localStorage.getItem('wizardInfo_dyoe'); 
    let wizardStart;
    wizardStart= JSON.parse(localStorage.getItem('wizardStart'));
    let price;
    let priceStone;
    
    if (wizardInfo != null) {
        wizardInfo = JSON.parse(wizardInfo);   
        price = currentCurrencySymbol+' '+toNumberFormat((wizardInfo.setting_variant_price/100)); 
        priceStone = currentCurrencySymbol+' '+toNumberFormat(wizardInfo.stone_price * currentRate );
    }
    else {
        wizardInfo = window.wizard;
    }
    if(wizardInfo != null){
    let stone_image_url = wizardInfo.stone_image_url;
     if(stone_image_url != null ){
    $('.banner_size_images').find('.banner_size_each img').attr('src',stone_image_url);
    }
  }
    switch (window.wizard.stepId) {
        case 1:
            var totalCarat = (parseFloat(wizardInfo.stone_carat) + parseFloat(wizardInfo.stone_carat1)).toFixed(2);
            document.getElementById("nro-1").innerHTML=1;
            document.getElementById("nro-2").innerHTML=2;  
            let step1 = document.getElementById("step1");
            step1.classList.add('step-select');
            stepPrev = document.getElementById("step0");
            stepPrev.classList.add('step-border');
            if(wizardInfo.stone_shape){
                document.getElementById('col-step-1').classList.add('col-wizard-margin-selected');
                document.getElementById('title-1-step1').innerHTML = `Choose Diamonds`;           
                document.getElementById('info-wizard-step-1').innerHTML = `${totalCarat} ${wizardInfo.stone_shape} - ${priceStone}`;               
                document.getElementById('img-wizard-step1').src=`${wizardInfo.stone_image_url}`;
                // if the user is in diamond-detail page, we need to show the link to go back to diamond list page
                let step1Links = `<a class="title-step title-middle" href="/pages/lab-grown-diamond-detail-dyoe?did=${wizardInfo.stone_id}">View</a>`;
                if (window.location.href.indexOf("diamond-detail") > -1) {
                    step1Links += ` / <a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;
                }
                document.getElementById('subtitle-1-step1').innerHTML = step1Links;
                document.getElementById('img-wizard-step1').classList.add('img-step-1-selected-diamond');
            }
            else {
                document.getElementById('title-1-step1').innerHTML = `Choose Diamonds`;
                //document.getElementById('col-step-1').classList.add('col-wizard-margin-Noselected');
                document.getElementById('info-wizard-step-2').style.display="none";               
                document.getElementById('img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                document.getElementById('img-wizard-step1').classList.add('img-step-1-noSelected-diamond');
                
            }            
            /**Step 2 NO selected RING */
            if(wizardInfo.setting_product_name){
              //document.getElementById('title-1-step2').innerHTML = `Choose Setting`;
              document.getElementById('title-1-step2').classList.add('col-wizard-margin-selected');
              document.getElementById('title-1-step2').innerHTML= `${wizardInfo.setting_product_name} `; 
              document.getElementById('info-wizard-step-2').innerHTML= `${price} `; 
              document.getElementById('subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
              document.getElementById('img-wizard-step2').src=`${wizardInfo.setting_image_url}`;
              document.getElementById('img-wizard-step2').classList.add('img-step-2-selected');
              //document.getElementById('img-wizard-step1').classList.add('img-step-1-noSelected');
            }
            else {
                document.getElementById('title-1-step2').innerHTML = `Choose Setting`;
                //document.getElementById('col-step-2').classList.add('col-wizard-margin-Noselected');
                document.getElementById('info-wizard-step-2').style.display="none";               
                document.getElementById('img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/earrings.png?v=1752575110`;
                document.getElementById('img-wizard-step2').classList.add('img-step-2-noSelected');
            }
            /**Step 3 NO selected */
            if(wizardInfo.setting_variant_id && wizardInfo.stone_shape){
                //document.getElementById('col-step-3').classList.add('col-wizard-margin-Noselected');
            }
            else {
                //document.getElementById('col-step-3').classList.add('col-wizard-margin-Noselected');
            }
           
            
            break;
        case 2:
            console.log('case 2');

            document.getElementById("nro-1").innerHTML=1;
            document.getElementById("nro-2").innerHTML=2;  
            let step2 = document.getElementById("step2");
            step2.classList.add('step-select');
            stepPrev = document.getElementById("step1");
            stepPrev.classList.add('step-border');
            var totalCarat = (parseFloat(wizardInfo.stone_carat) + parseFloat(wizardInfo.stone_carat1)).toFixed(2);
            if(wizardInfo.stone_shape){
                document.getElementById('col-step-1').classList.add('col-wizard-margin-selected');
                document.getElementById('title-1-step1').innerHTML = `Choose Diamonds`;           
                document.getElementById('info-wizard-step-1').innerHTML = `${totalCarat} ${wizardInfo.stone_shape} - ${priceStone}`;               
                document.getElementById('img-wizard-step1').src=`${wizardInfo.stone_image_url}`;
                document.getElementById('img-wizard-step1').classList.add('img-step-1-selected-diamond');
                document.getElementById('subtitle-1-step1').innerHTML = `<a class="title-step title-middle" href="/pages/lab-grown-diamond-detail-dyoe?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
            }
            else {
                //document.getElementById('col-step-1').classList.add('col-wizard-margin-Noselected');
                document.getElementById('title-1-step1').innerHTML = `Choose Diamonds`;
                document.getElementById('img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                document.getElementById('img-wizard-step1').classList.add('img-step-1-noSelected-diamond'); 
            }

            if(wizardInfo.setting_product_name){
                document.getElementById('title-1-step2').classList.add('col-wizard-margin-selected');
                document.getElementById('title-1-step2').innerHTML= `${wizardInfo.setting_product_name} `; 
                document.getElementById('info-wizard-step-2').innerHTML= `${price} `; 
                document.getElementById('subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
                document.getElementById('img-wizard-step2').src=`${wizardInfo.setting_image_url}`;
                document.getElementById('img-wizard-step2').classList.add('img-step-2-selected');
            }
            else {
              let pd_title = $('.product__info-wrapper .product__title.mb_6.small-hide h1').text();
              let main_price =  $('.product__info-container .price-item--regular').html();
              if(pd_title != ''){
                document.getElementById('title-1-step2').innerHTML = pd_title;
              }else{
                 document.getElementById('title-1-step2').innerHTML = `Choose Diamonds`;
              }
                //document.getElementById('col-step-2').classList.add('col-wizard-margin-Noselected');
              if(main_price != ''){
                document.getElementById('info-wizard-step-2').innerHTML = main_price; 
                document.getElementById('info-wizard-step-2').style.display="block";
              }else{
                  document.getElementById('info-wizard-step-2').style.display="none";
              }
              if(pd_title != '' && main_price != ''){
              document.getElementById('subtitle-1-step2').innerHTML = ` <a class="title-step title-middle" onclick="changeWizardSelection('setting')">Change</a>`;
            }
                document.getElementById('img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/earrings.png?v=1752575110`;
                document.getElementById('img-wizard-step2').classList.add('img-step-2-noSelected');
            }
        
            /**Step 3 NO selected */
            if(wizardInfo.setting_variant_id && wizardInfo.stone_shape){
                //document.getElementById('col-step-3').classList.add('col-wizard-margin-Noselected');
             
            }
            else {
                //document.getElementById('col-step-3').classList.add('col-wizard-margin-Noselected');

            }
        
        
        
            break;                
        case 3:
            console.log('case 3');
            document.getElementById("nro-1").innerHTML=1;
            document.getElementById("nro-2").innerHTML=2;  

            step3 = document.getElementById("step3");
            step3.classList.add('step-select-3');
            stepPrev = document.getElementById("step2");
            stepPrev.classList.add('step-border');

           if(wizardInfo.stone_shape){
                /**Step 2 selected */
               /**Step 2 NO selected */
               var totalCarat = (parseFloat(wizardInfo.stone_carat) + parseFloat(wizardInfo.stone_carat1)).toFixed(2);
                document.getElementById('col-step-1').classList.add('col-wizard-margin-selected');
                document.getElementById('title-1-step1').innerHTML = `Choose Diamonds`;           
                document.getElementById('info-wizard-step-1').innerHTML = `${totalCarat} ${wizardInfo.stone_shape} - ${priceStone}`;               
                document.getElementById('img-wizard-step1').src=`${wizardInfo.stone_image_url}`;
                document.getElementById('img-wizard-step1').classList.add('img-step-1-selected-diamond');
                document.getElementById('subtitle-1-step1').innerHTML = `<a class="title-step title-middle" href="/pages/lab-grown-diamond-detail-dyoe?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
            }
            else {
                //document.getElementById('col-step-1').classList.add('col-wizard-margin-Noselected');
                document.getElementById('title-1-step1').innerHTML = `Choose Diamonds`;
                //document.getElementById('subtitle-1-step2').innerHTML = ` <a class="title-step title-middle" href="/pages/dyor-diamonds">Browse Diamonds</a>`;
                document.getElementById('img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                document.getElementById('img-wizard-step1').classList.add('img-step-1-noSelected-diamond'); 
            }

            if(wizardInfo.setting_product_name){
                //document.getElementById('title-1-step2').innerHTML = `Choose Setting`;
                document.getElementById('title-1-step2').classList.add('col-wizard-margin-selected');
                document.getElementById('title-1-step2').innerHTML= `${wizardInfo.setting_product_name} `; 
                document.getElementById('info-wizard-step-2').innerHTML= `${price} `; 
                document.getElementById('subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
                document.getElementById('img-wizard-step2').src=`${wizardInfo.setting_image_url}`;
                document.getElementById('img-wizard-step2').classList.add('img-step-2-selected');
                //document.getElementById('img-wizard-step1').classList.add('img-step-1-noSelected');
            }
            else {
                /**Step 2 selected */
                document.getElementById('title-1-step2').innerHTML = `Choose Setting`;
                //document.getElementById('col-step-2').classList.add('col-wizard-margin-Noselected');
                document.getElementById('info-wizard-step-2').style.display="none";               
                document.getElementById('img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/earrings.png?v=1752575110`;
                document.getElementById('img-wizard-step2').classList.add('img-step-2-noSelected');
            }
            /**Step 3 NO selected */
            //document.getElementById('col-step-3').classList.add('col-wizard-margin-Noselected');
        

            break;
        default:
            break;
    }            


}
function loadMobileWizard(){
    let currentCurrency = Shopify.currency.active;
    let currentCurrencySymbol = $('body').attr('data-currency');
    let currentRate = window.Shopify.currency.rate;
    let wizardSessionDate = JSON.parse(localStorage.getItem('wizardSessionDate'));
    if(wizardSessionDate){
        // let's parse the date
        let date = new Date(wizardSessionDate);
        //if more than 4 hours have passed let's clear the wizard/localStorage and all that stuff
        if((new Date() - date) > 14400000){
            localStorage.removeItem('wizardInfo_dyoe');
            localStorage.removeItem('wizardStart');
            localStorage.removeItem('wizardSessionDate');
            localStorage.removeItem('latestSearch');
            localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));
        }
        else {
            localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));
        }
    }
    else {
        // Not even a date, let's clear the localStorage
        localStorage.removeItem('wizardInfo_dyoe');
        localStorage.removeItem('wizardStart');
        localStorage.removeItem('wizardSessionDate');
        localStorage.removeItem('latestSearch');
        localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));

    }
    let step1, stp2, step3;
    let choose1, choose2, choose3;
    let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));

let wizardInfo;
    wizardInfo = localStorage.getItem('wizardInfo_dyoe'); 
    wizardStart= JSON.parse(localStorage.getItem('wizardStart'));
    let price;
    let priceStone;
    let settingSelected = false;
    let stoneSelected = false;
    
    if (wizardInfo != null) {
        wizardInfo = JSON.parse(wizardInfo); 
        
        price = currentCurrencySymbol+' '+toNumberFormat((wizardInfo.setting_variant_price/100) * currentRate); 
         priceStone = currentCurrencySymbol+' '+toNumberFormat(wizardInfo.stone_price * currentRate );
    }
    else {
        wizardInfo = window.wizard;
    }
    if(wizardStart == 'StartWithDiamond'){
    switch (window.wizard.stepId) {
        
        case 1:
        if(wizardInfo.stone_shape){  
                  document.getElementById('title-1-step1_mob').innerHTML = `Choose Diamonds:`;  
                    document.getElementById('title-1-step2_mob').innerHTML = `Choose Setting :`;
                    document.getElementById('subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/pages/lab-grown-diamond-detail-dyoe?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
                }else{
                 document.getElementById('title-1-step1_mob').innerHTML = `Choose Diamonds:`;  
                document.getElementById('title-1-step2_mob').innerHTML = `Choose Setting :`;
                }
              if(wizardInfo.setting_product_name){
                    settingSelected = true;
                     /**Step 1 selected */
                     document.getElementById('title-1-step1_mob').innerHTML = `Choose Diamonds:`;  
                    document.getElementById('title-1-step2_mob').innerHTML = `Choose Setting:`;
                    document.getElementById('subtitle-1-step2_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
                }else{
                 document.getElementById('title-1-step1_mob').innerHTML = `Choose Diamonds:`;  
                    document.getElementById('title-1-step2_mob').innerHTML = `Choose Setting:`;
                }
            break;
        case 2:
     if(wizardInfo.stone_shape){  
               document.getElementById('title-1-step1_mob').innerHTML = `Choose Diamonds:`;  
                document.getElementById('title-1-step2_mob').innerHTML = `Choose Setting:`;
               document.getElementById('subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/pages/lab-grown-diamond-detail-dyoe?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
            }
            else {
               document.getElementById('title-1-step1_mob').innerHTML = `Choose  Diamonds :`;  
                    document.getElementById('title-1-step2_mob').innerHTML = `Choose Setting:`;
              document.getElementById('subtitle-1-step1_mob').innerHTML =`To Be Selected`
            }
           if(wizardInfo.setting_product_name){
               document.getElementById('title-1-step1_mob').innerHTML = `Choose Setting :`;  
                document.getElementById('title-1-step2_mob').innerHTML = `Choose Diamonds:`;
              document.getElementById('subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
             }else {
               document.getElementById('title-1-step1_mob').innerHTML = `Choose Diamonds:`;  
                  document.getElementById('title-1-step2_mob').innerHTML = `Choose Setting:`;
              document.getElementById('subtitle-1-step2_mob').innerHTML =`To Be Selected`
            }
            /**Step 3 NO selected */
          
            break;
        case 3:                
            /**Step 1 NO selected */
         if(wizardInfo.stone_shape){  
              document.getElementById('title-1-step1_mob').innerHTML = `Choose  Diamonds :`;  
                document.getElementById('title-1-step2_mob').innerHTML = `Choose Setting:`;
           document.getElementById('subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/pages/lab-grown-diamond-detail-dyoe?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
         }
            document.getElementById('subtitle-1-step2_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                              
            
           /**Step 3  selected */
            break;
        default:
            break;
    }
    }else{
      switch (window.wizard.stepId) {
        case 1:
               if(wizardInfo.stone_shape){  
                  document.getElementById('title-1-step1_mob').innerHTML = `Choose  Diamonds :`;  
                    document.getElementById('title-1-step2_mob').innerHTML = `Choose Setting:`;
                    document.getElementById('subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/pages/lab-grown-diamond-detail-dyoe?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
                }else{
                 
                }
              if(wizardInfo.setting_product_name){
                    settingSelected = true;
                     /**Step 1 selected */
                     document.getElementById('title-1-step1_mob').innerHTML = `Choose  Diamonds :`;  
                    document.getElementById('title-1-step2_mob').innerHTML = `Choose Setting:`;
                    document.getElementById('subtitle-1-step2_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
                }
            break;
        case 2:
        if(wizardInfo.stone_shape){  
               document.getElementById('title-1-step1_mob').innerHTML = `Choose  Diamonds :`;  
                    document.getElementById('title-1-step2_mob').innerHTML = `Choose Setting:`;
               document.getElementById('subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/pages/lab-grown-diamond-detail-dyoe?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
            }
            else {
               document.getElementById('title-1-step1_mob').innerHTML = `Choose  Diamonds :`;  
                    document.getElementById('title-1-step2_mob').innerHTML = `Choose Setting:`;
              document.getElementById('subtitle-1-step1_mob').innerHTML =`To Be Selected`
            }
           if(wizardInfo.setting_product_name){
               document.getElementById('title-1-step1_mob').innerHTML = `Choose Setting :`;  
                document.getElementById('title-1-step2_mob').innerHTML = `Choose Diamonds:`;
              document.getElementById('subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                       
             }else {
               document.getElementById('title-1-step1_mob').innerHTML = `Choose Setting :`;  
                  document.getElementById('title-1-step2_mob').innerHTML = `Choose Diamonds:`;
              document.getElementById('subtitle-1-step2_mob').innerHTML =`To Be Selected`
            }
            /**Step 3 NO selected */
          
            break;
        case 3:                
            /**Step 1 NO selected */
         if(wizardInfo.stone_shape){  
              document.getElementById('title-1-step1_mob').innerHTML = `Choose  Diamonds :`;  
                document.getElementById('title-1-step2_mob').innerHTML = `Choose Setting:`;
           document.getElementById('subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/pages/lab-grown-diamond-detail-dyoe?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelection('diamond')">Change</a>`;;
         }
            document.getElementById('subtitle-1-step2_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelection('setting')"> Change</a>`;                              
            
           /**Step 3  selected */
            break;
        default:
            break;
    }
    }
}

loadWizard();
$(window).on("load resize",function(){
    let screenWidth = screen.width;
    wizardStart = JSON.parse(localStorage.getItem('wizardStart'));  
    if (screenWidth >= 800) {
        switch (wizardStart) {
            case 'StartWithSetting':        
                loadDesktopStartWithSettingWizard();
                break;

            case 'StartWithDiamond':
                setTimeout(function(){
                loadDesktopStartWithDiamondWizard();
                  },1000)
                break;

            default:
                break;
        }
    } else {
        loadMobileWizard();
        }
});

